import React, { useState } from 'react';
import { FiWifiOff as WifiOff, FiRefreshCw as RefreshCw } from 'react-icons/fi';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';
import { applyUpdate } from '../../pwa/registerServiceWorker';

/**
 * Two thin status strips pinned under the top nav: one when the device drops
 * offline, one when a new version of the app is ready to load.
 */
const ConnectionBanner = ({ updateRegistration }) => {
  const isOnline = useOnlineStatus();
  const [updating, setUpdating] = useState(false);
  const [updateFailed, setUpdateFailed] = useState(false);

  if (!isOnline) {
    return (
      <div
        role="status"
        className="fixed top-20 inset-x-0 z-40 bg-gray-900 text-white text-sm py-2 px-4 flex items-center justify-center gap-2"
      >
        <WifiOff size={16} />
        <span>You're offline — showing your saved information</span>
      </div>
    );
  }

  if (updateRegistration) {
    return (
      <div
        role="status"
        className="fixed top-20 inset-x-0 z-40 bg-[#0038A8] text-white text-sm py-2 px-4 flex items-center justify-center gap-3"
      >
        <span>{updateFailed ? "That update didn't take — reload to try again" : 'A new version is available'}</span>
        <button
          onClick={() => {
            setUpdateFailed(false);
            setUpdating(true);
            // If nothing is waiting, no controllerchange and no reload will
            // follow. Leaving the button disabled on "Updating…" would be a
            // spinner that never resolves.
            if (!applyUpdate(updateRegistration)) {
              setUpdating(false);
              setUpdateFailed(true);
            }
          }}
          disabled={updating}
          className="inline-flex items-center gap-1.5 bg-white/15 hover:bg-white/25 disabled:opacity-60 px-3 py-1 rounded-md font-semibold transition-colors"
        >
          <RefreshCw size={14} className={updating ? 'animate-spin' : ''} />
          {updating ? 'Updating…' : updateFailed ? 'Retry' : 'Update'}
        </button>
      </div>
    );
  }

  return null;
};

export default ConnectionBanner;
